let http;
let uri;
let cancelFn;

import Moment from 'moment-timezone';
import axios from 'axios'
import {filter, isArray, isNumber, isString} from "lodash";

export class BaseResource
{
    createCancelToken() {
        return new axios.CancelToken(function executor(c) {
            cancelFn = c;
        })
    }

    cancelCurrentRequest() {
        if (cancelFn) {
            cancelFn();
            cancelFn = null;
        }
    }

    static setBaseUri(address) {
        uri = address;
    }

    getBaseUri() {
        return uri;
    }

    static setHttp(client) {
        http = client;
    }

    getHttp() {
        return http;
    }

    _normalizeData(data) {
        if (!data || data instanceof FormData) {
            return data;
        }
        
        data = Object.assign({}, data);

        for (var i in data) {
            if (data.hasOwnProperty(i)) {
                if (data[i] instanceof Moment || data[i] instanceof Date) {
                    data[i] = new Moment(data[i]).tz('UTC').format();
                } else if (typeof data[i] === 'object') {
                    data[i] = this._normalizeData(data[i]);
                }
            }
        }

        return data;
    }

    _buildSegments(pathSegments = []) {

        let segments = [uri]

        if (isArray(this.resourceSegments)) {
            segments = segments.concat(this.resourceSegments)
        }

        segments = filter(segments.concat(pathSegments), o => isString(o) || isNumber(o))

        return segments.join('/')
    }

    _doGet(segments = [], params = {}, config = {}) {
        return this.getHttp().get(this._buildSegments(segments), Object.assign({ params }, config));
    }

    _doPost(segments = [], data = {}, params = {}, config = {}) {
        return this.getHttp().post(
            this._buildSegments(segments), 
            this._normalizeData(data), 
            Object.assign({ params }, config)
        );
    }

    _doPut(segments = [], data = {}, params = {}, config = {}) {
        return this.getHttp().put(
            this._buildSegments(segments), 
            this._normalizeData(data), 
            Object.assign({ params }, config)
        );
    }

    _doPatch(segments = [], data = {}, params = {}, config = {}) {
        return this.getHttp().patch(
            this._buildSegments(segments),
            this._normalizeData(data),
            Object.assign({ params }, config)
        );
    }

    _doDelete(segments = [], params = {}, config = {}) {
        return this.getHttp().delete(
            this._buildSegments(segments), 
            Object.assign({ params }, config)
        );
    }
}

export default class Resource extends BaseResource
{
    constructor(handle, resourceSegments = []) {
        super()
        this.handle = handle
        this.resourceSegments = resourceSegments;
    }

    getHandle() {
        return this.handle
    }

    all(params = {}, config = {}) {
        return this._doGet([], params, config);
    }

    store(data = {}, params = {}, config = {}) {
        return this._doPost([], data, params, config);
    }

    storeOrUpdate(id, data = {}, params = {}, config = {}) {
        if (id) {
            return this.update(id, data, params, config);
        }

        return this.store(data, params, config);
    }

    update(id, data = {}, params = {}, config = {}) {
        return this._doPost([id], data, params, config);
    }

    find(id, params = {}, config = {}) {
        return this._doGet([id], params, config);
    }

    destroy(id, params = {}) {
        return this._doDelete([id], params);
    }
}